import React from 'react';
import { ReactDatePickerProps } from 'react-datepicker';
import './ReportPeriod.css';

export type ReportPeriodMode = 'monthly' | 'custom';

interface PeriodModeToggleProps {
    options: { value: ReportPeriodMode; label: string }[];
    value: ReportPeriodMode;
    onChange: (value: ReportPeriodMode) => void;
    ariaLabel: string;
}

// Segmented Monthly | Custom control for the Balance Sheet / Statement of Income toolbars: one track
// with equal-width segments, so switching never resizes it. It is not a filter field: switching mode
// clears the report, while the month/date fields beside it are drafts for Generate.
// Clicking the active mode does nothing.
export const PeriodModeToggle: React.FC<PeriodModeToggleProps> = ({ options, value, onChange, ariaLabel }) => (
    <div className="period-mode-toggle" role="group" aria-label={ariaLabel}>
        {options.map((option) => (
            <button
                key={option.value}
                type="button"
                aria-pressed={value === option.value}
                className={`period-mode-toggle__option${value === option.value ? ' is-active' : ''}`}
                onClick={() => value !== option.value && onChange(option.value)}
            >
                {option.label}
            </button>
        ))}
    </div>
);

// Calendar popup for the report toolbars: rendered in a body-level portal so no parent overflow can clip
// it and the report never moves; opens 6px below the input and flips above when the viewport needs it.
export const reportDatePickerProps: Partial<ReactDatePickerProps> = {
    portalId: 'report-period-datepicker-portal',
    popperClassName: 'report-period-datepicker-popper',
    popperPlacement: 'bottom-start',
    popperModifiers: [
        { name: 'offset', options: { offset: [0, 6] } },
        { name: 'flip', options: { fallbackPlacements: ['top-start', 'bottom-end', 'top-end'] } },
        { name: 'preventOverflow', options: { rootBoundary: 'viewport', padding: 8 } },
    ],
};
